import { useCallback, useEffect } from 'react'
import { NavLink, Outlet, useNavigate, useSearchParams } from 'react-router-dom'
import { AuthProvider, useAuthContext } from './auth/AuthContext.tsx'
import { NexOrganixFooter, NexOrganixLogo } from './components/Bits.tsx'
import { ThemeToggle } from './components/ThemeToggle.tsx'

function TopBar() {
  const { authenticated, isAdmin, logout } = useAuthContext()
  return (
    <header className="topbar">
      <div className="topbar__brand">
        Val i Ale <small>2026 · kommunfullmäktige</small>
      </div>
      <nav className="topbar__nav">
        <NavLink to="/" end className={({ isActive }) => (isActive ? 'is-active' : '')}>
          Valvaka
        </NavLink>
        {authenticated ? (
          <>
            <NavLink to="/simulering" className={({ isActive }) => (isActive ? 'is-active' : '')}>
              Simulering
            </NavLink>
            {isAdmin && (
              <NavLink to="/admin" className={({ isActive }) => (isActive ? 'is-active' : '')}>
                Admin
              </NavLink>
            )}
            <NavLink to="/konto" className={({ isActive }) => (isActive ? 'is-active' : '')}>
              Byt lösenord
            </NavLink>
            <button type="button" className="topbar__nav-btn" onClick={() => logout()}>
              Logga ut
            </button>
          </>
        ) : (
          <NavLink to="/login" className={({ isActive }) => (isActive ? 'is-active' : '')}>
            Logga in
          </NavLink>
        )}
        <ThemeToggle />
      </nav>
    </header>
  )
}

export function App() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const kiosk = params.get('kiosk') === '1'

  useEffect(() => {
    document.documentElement.toggleAttribute('data-kiosk', kiosk)
    document.body.classList.toggle('is-kiosk', kiosk)
  }, [kiosk])

  const exitKiosk = useCallback(() => {
    if (document.fullscreenElement) document.exitFullscreen?.().catch(() => {})
    const p = new URLSearchParams(window.location.search)
    p.delete('kiosk')
    navigate({ pathname: '/', search: p.toString() })
  }, [navigate])

  useEffect(() => {
    if (!kiosk) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !document.fullscreenElement) exitKiosk()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [kiosk, exitKiosk])

  return (
    <AuthProvider>
      <div className={`app${kiosk ? ' app--kiosk' : ''}`}>
        {!kiosk && <TopBar />}
        <main className="app__main">
          <Outlet context={{ kiosk }} />
        </main>
        {kiosk ? (
          <>
            <div className="kiosk-brand">
              <NexOrganixLogo height={26} />
            </div>
            <button
              type="button"
              className="kiosk-exit"
              onClick={exitKiosk}
              title="Avsluta kioskläge (Esc)"
            >
              Avsluta kiosk
            </button>
          </>
        ) : (
          <NexOrganixFooter />
        )}
      </div>
    </AuthProvider>
  )
}
